// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","headerBox":"Header_headerBox__1lokh","headerLogo":"Header_headerLogo__pHUY0"};